import { useActivePractice } from '@witmetrics/data-store';
import type { ShortcutKey } from '@/types';
import CommandPalette from '@/components/CommandPalette';
import { LightningIcon } from '@/icons';
import { LAB_SHORTCUTS, PRACTICE_SHORTCUTS } from './constants';

export type ShortcutsDialogProps = {
  onSelect: (shortcut: ShortcutKey) => void;
  onClose: () => void;
};

export default function ShortcutsDialog({
  onSelect,
  onClose,
}: ShortcutsDialogProps) {
  const activePractice = useActivePractice();

  return (
    <CommandPalette
      icon={<LightningIcon size="1.125rem" />}
      title="Quick actions"
      subtitle="Type or click a shortcut"
      items={activePractice ? PRACTICE_SHORTCUTS : LAB_SHORTCUTS}
      onSelect={onSelect}
      onClose={onClose}
    />
  );
}
